import { DataOrigin, PaymentMethod } from '@/app/shared/enums';
import { ContractModel } from '@/app/shared/models/billing/contract.model';
import { PolicyModel } from '@/app/shared/models/insurance/policy.model';
import { Model } from '@/app/shared/models/model';

export class DataFilterModel extends Model {
  public Id!: string;
  public DataOrigin!: DataOrigin;
  public CustomerName!: string;
  public CustomerDocument!: string;
  public Number!: string;
  public PaymentMethod!: PaymentMethod;
  public OurCode!: string;
  public OffSet!: number;
  public Limit!: number;
  public TenantId!: string;
  public TenantName!: string;
  public CompanyId!: string;
  public CardTruncatedNumber!: string;
  public BranchNumber!: string;
  public AccountNumber!: string;
  public AuthorizationCode!: string;
  public Tid!: string;
  public Nsu!: string;
  public LuckNumber!: string;
  public Status!: string;
  public StatusList!: string[];
  public Contract!: ContractModel;
  public Policy!: PolicyModel;
  public ContractParentId?: string;
  public ContractStartDate?: Date;
  public ContractProductCode?: string;
  public ContractNumberOfInstallments?: number;
  public ContractFirstInstallmentNumber?: number;
  public MSISDN?: string;

  constructor() {
    super();
    this.CustomerName = '';
    this.CustomerDocument = '';
    this.OurCode = '';
    this.Number = '';
    this.CardTruncatedNumber = '';
    this.BranchNumber = '';
    this.AccountNumber = '';
    this.AuthorizationCode = '';
    this.Tid = '';
    this.Nsu = '';
    this.LuckNumber = '';
    this.Status = '';
  }
}
